import { api } from './api';
import { UserProfile, IUserProfileService } from '../types/user';

/**
 * User Profile Service Implementation
 *
 * Implements IUserProfileService interface for API-based profile operations.
 * This pattern allows easy swapping of implementations (e.g., mock, offline).
 *
 * @implements {IUserProfileService}
 */
export const userProfileService: IUserProfileService = {
  getProfile: (): Promise<UserProfile> => api.get<UserProfile>('/profile'),

  updateProfile: (data: Partial<UserProfile>): Promise<UserProfile> =>
    api.patch<UserProfile>('/profile', data),
};
